import React, {useRef, useState} from 'react';
import PropTypes from 'prop-types';
import ReactJoyride from 'react-joyride';
import {TourBox} from './TourBox';

/**
 * Page Tour:
 *  - Showcase your app to new users or explain functionality of new features.
 */
export function PageTour(props) {
  const ref = useRef('joyride');
  const [currentIndex, setCurrentIndex] = useState(0);

  React.useEffect(() => {
    // props.setInitalState(props);
  }, []);

  const handleJoyrideCallback = (payload) => {
    setCurrentIndex(payload.index);
    props.handleJoyrideCallback(payload);
  };

  const isSpotlightClicks = () => {
    return props.steps.length && props.steps[currentIndex].spotlightClicks
      ? true
      : false;
  };

  const getSpotLightRadius = () => {
    return props.steps.length && props.steps[currentIndex].spotlightRadius
      ? props.steps[currentIndex].spotlightRadius
      : '5px';
  };

  const Tooltip = (props) => <TourBox {...props} />;

  return (
    <ReactJoyride
      ref={ref}
      disableScrollParentFix={true}
      steps={props.steps}
      stepIndex={props.stepIndex}
      continuous={true}
      tooltipComponent={Tooltip}
      showSkipButton={true}
      run={props.run}
      disableOverlayClose={true}
      spotlightClicks={isSpotlightClicks()}
      callback={handleJoyrideCallback}
      styles={{
        options: {
          zIndex: 1000,
          width: "100%",
          height: "100%"
        },
        spotlight: {
          borderRadius: getSpotLightRadius(),
        },
      }}
    />
  );
}

PageTour.propTypes = {
  /**
   * The step is a plain object that only requires two properties to be valid: target and content
   */
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Target can be a CSS selector or an HTMLElement directly (but using refs created in the same render would required an additional render afterwards)
       */
      target: PropTypes.string.isRequired,
      /**
       * Content is the tooltip's body.
       */
      content: PropTypes.string,
      /**
       * SpotLightClick allows Clicks through the hole
       */
      spotlightClicks: PropTypes.bool,
      /**
       * The placement of the beacon and tooltip. It will re-position itself if there's no space available
       */
      placement: PropTypes.string,
      /**
       * Custom border radius for spotLight
       */
      spotlightRadius: PropTypes.string,
    })
  ).isRequired,
  /**
   * Boolean value to show/hide tour initialy
   */
  run: PropTypes.bool.isRequired,
  /**
   * Setting a number here will turn Tour component into controlled mode
   */
  stepIndex: PropTypes.number.isRequired,
};

PageTour.defaultProps = {steps: [], run: false, stepIndex: 0};
